module.exports = __webpack_public_path__ + "static/media/history.bb245628.svg";